export default __webpack_public_path__ + "static/media/smartagent.197f2502.png";